<template>
  <a-card>
    <template #extra>
      <a-segmented v-model:value="status" :options="statusOptions" @change="fetchData" />
    </template>
    <a-table :data-source="data" :columns="columns" :row-key="record => record.id" :loading="loading">
      <template #createTime="{ record }">
        {{ formatDate(record.createTime) }}
      </template>
      <template #status="{ record }">
        <a-tag :color="record.status === 0 ? 'blue' : record.status === 1 ? 'green' : 'red'">
          {{ statusText(record.status) }}
        </a-tag>
      </template>
      <template #action="{ record }">
        <div v-if="record.status === 0" style="display:flex;gap:8px;">
          <a-button size="small" type="primary" @click="approve(record.id)">同意</a-button>
          <a-button size="small" danger @click="reject(record.id)">拒绝</a-button>
        </div>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue'
import { getAppUsers, getRequests, approveRequest, rejectRequest } from '@/api/TikuComponentApi'
import { message } from 'ant-design-vue'
import { asArrayResult } from '@/utils/result'

const statusOptions = [
  { label: '全部', value: -1 },
  { label: '待处理', value: 0 },
  { label: '已同意', value: 1 },
  { label: '已拒绝', value: 2 },
]

export default defineComponent({
  name: 'RequestList',
  setup() {
    const data = ref([])
    const status = ref(-1)
    const loading = ref(false)
    const columns = [
      { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
      { title: '用户名', dataIndex: 'displayName', key: 'displayName', width: 160 },
      { title: '申请数量', dataIndex: 'amount', key: 'amount', width: 120 },
      { title: '理由', dataIndex: 'reason', key: 'reason' },
      { title: '状态', dataIndex: 'status', key: 'status', slots: { customRender: 'status' }, width: 120 },
      { title: '申请时间', dataIndex: 'createTime', key: 'createTime', slots: { customRender: 'createTime' }, width: 180 },
      { title: '操作', dataIndex: 'action', key: 'action', slots: { customRender: 'action' }, width: 160 },
    ]

    const statusText = (s) => {
      return s === 0 ? '待处理' : s === 1 ? '已同意' : '已拒绝'
    }

    const fetchUserDirectory = async () => {
      const res = await getAppUsers()
      if (res?.status !== 200) {
        return {}
      }
      const items = asArrayResult(res.data)
      return items.reduce((acc, item) => {
        const sub = String(item?.sub || '').trim()
        if (!sub) {
          return acc
        }
        acc[sub] = item?.nickname || item?.username || sub
        return acc
      }, {})
    }

    const fetchData = () => {
      loading.value = true
      Promise.all([getRequests({ status: status.value }), fetchUserDirectory()]).then(([res, userMap]) => {
        if (res.status === 200) {
          data.value = asArrayResult(res.data).map(item => ({
            ...item,
            displayName: userMap[item.authUserId] || item.authUsername || item.authUserId,
          }))
        } else {
          data.value = []
          message.error(res.message || '获取申请列表失败')
        }
      }).finally(() => loading.value = false)
    }

    const formatDate = (value) => {
      if (!value) return '-'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return '-'
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }

    const approve = (id) => {
      approveRequest(id).then(res => {
        if (res.status === 200) {
          message.success('已同意')
          fetchData()
        } else {
          message.error(res.message || '操作失败')
        }
      })
    }
    const reject = (id) => {
      rejectRequest(id).then(res => {
        if (res.status === 200) {
          message.success('已拒绝')
          fetchData()
        } else {
          message.error(res.message || '操作失败')
        }
      })
    }

    onMounted(fetchData)

    return {
      data,
      status,
      loading,
      columns,
      statusOptions,
      statusText,
      formatDate,
      fetchData,
      approve,
      reject
    }
  }
})
</script>

<style scoped>
</style>
